// 約定履歴タブの KPI カード 6 枚 (AC-BIN-021) の値。
//
// 4 枚 (約定量〈買〉〈売〉・加重平均約定価格・約定率) はスポットの KPI と同じ式なので
// 共通の `computeExecutionKpi` を使い、 時間前にだけある 入札件数 / 約定済件数 (N / M) をここで足す。
// 母集合はエリア × 売買 別 集計 (AC-BIN-022b) と同じ `toExecutionSummaryRecords` の出力を渡す
// (AC-BIN-022b は母集合を AC-BIN-021 の約定率算出式と同一と定める。 KPI と集計表の数字が
// ずれないようにするため)。
//
// 収支のカードは持たない (AC-BIN-079)。
//
// TODO(business-logic): 集計は本来 BFF が返す値。 #3851 で
// `executionSummary.ts` と合わせてサーバー値の表示へ置き換える。
//
// 約定 0 件の表示:
//   - 加重平均約定価格: 約定量 0 は undefined (= 「—」。 AC-BIN-021 に定めが無く、 集計表の
//     「未約定の行は —」 とスポットの KPI に揃える)
//   - 約定率: 分母 (市場で評価された入札量) が 0 の時だけ undefined (= 画面では
//     docs/specs/conventions.md「数値表示」のゼロ除算の表記「0.0」)
import {
  type ExecutionKpi,
  computeExecutionKpi,
} from '~/components/bidding/common/executionSummary'
import type { IntradayExecutionSummaryRecord } from '~/pages/IntradayBidding/models/intradayExecutionSummary'

export type IntradayExecutionKpi = ExecutionKpi & {
  /** 入札件数 (= 母集合の全札数。 取消も、 送ったが届かず失効にした札も数える)。 */
  bidCount: number
  /** 約定済件数 (= 約定明細と同じ判定で約定済の札の数)。 「N / M」 の N。 */
  executedCount: number
}

export const computeIntradayExecutionKpi = (
  records: IntradayExecutionSummaryRecord[],
): IntradayExecutionKpi => {
  return {
    ...computeExecutionKpi(records),
    bidCount: records.length,
    executedCount: records.filter((record) => record.executed).length,
  }
}

export type FillRateTone = 'positive' | 'warning' | 'negative'

/**
 * 約定率カードの色分け (AC-BIN-021「値に応じた色分け。 具体閾値・色はデザイナー裁量」)。
 * 閾値は mock-app (`JepxIntradayResult.razor` の約定率 KPI: 80% 以上 / 50% 以上 / それ未満) の
 * 暫定値。 design (`intraday-result.html`) は約定率に色を付けていないので Des 確認待ち。
 */
export const fillRateTone = (
  fillRatePct: number | undefined,
): FillRateTone | undefined => {
  if (fillRatePct === undefined) return undefined
  if (fillRatePct >= 80) return 'positive'
  if (fillRatePct >= 50) return 'warning'
  return 'negative'
}
